export default class EnumItem {
  name?: string;

  //   constructor(name: string) {
  //     this.name = name;
  //   }
}
